import { EDevice } from '@/constants';
import type {
  IGTMEvent,
  IGtmPageVirtualEvent,
  IGTMSendProductsBilling,
  IGTMSendProductsBillingPurchase
} from '@/modules/perseo-billing/interfaces/src/front';
import { notifyError } from '@/modules/perseo-billing/services/error-handler';
import { getDeviceFromUrl } from '@/modules/perseo-billing/utils';
import { sendGtmEvent } from '@/modules/shared/utils/gtmEvents/Manager';
import { validateDeviceReadiness } from '@/modules/shared/utils/validateDeviceReadiness.ts';

export interface ISendEventParams {
  eventName: string;
  payload:
    | IGtmPageVirtualEvent
    | IGTMSendProductsBilling
    | IGTMSendProductsBillingPurchase
    | IGTMEvent;
}

export const sendEventByDevice = (params: ISendEventParams) => {
  const { eventName, payload } = params;
  const device = getDeviceFromUrl();

  try {
    validateDeviceReadiness(device);
    if (device === EDevice.IOS) {
      const message = {
        command: 'logEvent',
        name: eventName,
        parameters: payload
      };

      window?.webkit?.messageHandlers?.firebase?.postMessage(message);
    } else if (device === EDevice.ANDROID) {
      window?.AnalyticsWebInterface?.logEvent(
        eventName,
        JSON.stringify(payload)
      );
    } else {
      sendGtmEvent(payload);
    }
  } catch (error) {
    notifyError(error);
    console.error(`GTM: Couldn't send ${eventName} event`, error);
  }
};
